<template>
  <div>
    <div class="table-title-wrapper">
      <h6 class="text-uppercase rd-title" v-if="showTitle">Pupil Distances</h6>
      <b-button variant="icon-text-transparent mb-2 ml-2" @click="onClick">
        <span class="icon">
          <i class="di-create-18" />
        </span>
        <span class="text">Add PD</span>
      </b-button>
      <a @click="resetPd" v-show="selectable && selectedPd">Reset</a>
    </div>
    <ul class="list-unstyled rd-list pupil-distance-list">
      <PupilDistanceListItem
        v-for="pd in orderedPds"
        :key="pd.id"
        :pd="pd"
        :customerName="customerFullName"
        :selectable="selectable"
        :collapsible="collapsible"
        :expanded="expanded"
        :opened="pd.id === openId"
        :showProvider="showProvider"
        @edit="onEdit"
        @copy="onCopy"
        @duplicate="onDuplicate"
        @deleted="onDeleted"
      />
    </ul>
    <hr />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import PupilDistanceListItem from './PupilDistanceListItem.vue';
import uniquePds from '../support/uniquePds';

export default {
  name: 'PupilDistanceList',
  components: { PupilDistanceListItem },
  props: {
    customer: Object,
    showTitle: Boolean,
    selectable: Boolean,
    collapsible: Boolean,
    expanded: Boolean,
    showProvider: Boolean,
    openId: Number,
  },
  computed: {
    ...mapState({
      selectedPd: state => state.jobsModule.selectedPd,
    }),
    orderedPds() {
      const pds = [...(this.customer.pds?.data || [])].sort(
        (a, b) => this.$moment(b.created_at) - this.$moment(a.created_at),
      );
      return uniquePds(pds, this.selectable ? this._.get(this.selectedPd, 'detail.id') : null);
    },
    customerFullName() {
      return `${this.customer.first_name} ${this.customer.last_name}`;
    },
  },
  
  watch: {
    'customer.pds.data': {
      handler(newPds) {
        // Force re-render when PD data changes
        this.$forceUpdate();
      },
      deep: true
    }
  },
  mounted() {
    if (this.selectedPd) {
      const selectedPd = this._.find(this.orderedPds, {
        id: this._.get(this.selectedPd, 'detail.id'),
      });

      if (selectedPd) {
        this.$store.commit('jobsModule/SET_SELECTED_PD', {
          detail: selectedPd,
          pdPresenter: selectedPd.pdPresenter,
        });
      }
    }
    
    // Listen for PD updates to refresh the list
    this.$root.$on('newPdAdded', this.handlePdUpdate);
  },
  
  beforeDestroy() {
    this.$root.$off('newPdAdded', this.handlePdUpdate);
  },
  methods: {
    resetPd() {
      this.$store.commit('jobsModule/SET_SELECTED_PD', null);
    },
    onDuplicate(e) {
      this.$emit('duplicate', {
        customer: {
          id: this.customer.id,
          full_name: `${this.customer.first_name} ${this.customer.last_name}`,
        },
        pd: e.pd,
      });
    },
    onCopy(e) {
      this.$emit('copy', {
        customer: {
          id: this.customer.id,
          full_name: `${this.customer.first_name} ${this.customer.last_name}`,
        },
        pd: e.pd,
      });
    },
    onEdit(e) {
      this.$emit('edit', {
        customer: {
          id: this.customer.id,
          full_name: `${this.customer.first_name} ${this.customer.last_name}`,
        },
        pd: e.pd,
      });
    },
    onClick() {
      this.$emit('new', {
        customer: this.customer,
      });
    },
    onDeleted(e) {
      this.$root.$emit('newPdAdded');
      this.$emit('deleted', e);
    },
    
    handlePdUpdate(pdData = null) {
      // Force a re-render of the component when PD data is updated
      this.$forceUpdate();
      
      // If we have specific PD data, update the selected PD
      if (pdData && pdData.selectedId) {
        // Wait for the next tick to ensure the data is updated
        this.$nextTick(() => {
          const updatedPd = this.orderedPds.find(pd => pd.id === pdData.selectedId);
          if (updatedPd) {
            this.$store.commit('jobsModule/SET_SELECTED_PD', {
              detail: updatedPd,
              pdPresenter: updatedPd.pdPresenter,
            });
          }
        });
      }
    },
  },
};
</script>
